import { Match, Show, Switch } from "solid-js";
import useDenominationsGridDeprecated from "~/hooks/denominations_grid/useDenominationsGrid";
import { DenominationProps } from "~/components/denomination_grid/denominations_grid";
import { GcAmountHeader } from "./denominations_grid_webstore_telescope/gc_amount_header";
import { AmountSelectorLonger } from "./denominations_grid_webstore_telescope/amount_selector_longer";
import { AmountSelector } from "./denominations_grid_webstore_telescope/amount_selector";
import { GcAmountFooter } from "./denominations_grid_webstore_telescope/gc_amount_footer";
import { DenominationsGridWebstoreTelescopeProvider } from "./context/denominations_grid";
import { CustomAmountInput } from "./denominations_grid_webstore_telescope/custom_amount_input";

export type { DenominationProps } from "~/components/denomination_grid/denominations_grid";

/**
 * DenominationsGridV2 - New version following Telescope Design System
 *
 * This component uses the same props and hook as the original DenominationsGrid
 * but features a new UI with:
 * - Card-based layout with brand-colored header
 * - Telescope design system tokens
 * - Integrated amount display in header
 * - Cleaner, more modern styling
 */
export function DenominationsGridWebstoreTelescope(props: DenominationProps) {
  const gridState = useDenominationsGridDeprecated(props);
  const {
    isVariantBrand,
    denominationList,
    isCustomDenominationAllowed,
    customSelected,
  } = gridState;

  const { dryRunErrorMessage } = gridState.internalState;

  // Determine if we should show header with free text (editable amount)
  const isFreeTextHeader = () => {
    // Free text when custom denomination is allowed and denominations list is empty
    return isCustomDenominationAllowed;
  };

  // Hide amount selector if only one denomination and not custom
  // const shouldShowAmountSelector = () => {
  //   if (isVariantBrand) return true;
  //   if (denominationList.length === 0) return false;
  //   if (denominationList.length === 1 && !isCustomDenominationAllowed)
  //     return false;
  //   return true;
  // };

  // Extract brand color from brand metadata or use default
  const getBrandColor = () => {
    // Try to get brand color from brand metadata
    // Fallback to a default dark color if not available
    return props.brand.voucherProductMetadata.cardBackgroundColor;
    // return metadata.brandColor || "#1f3647";
  };

  return (
    <DenominationsGridWebstoreTelescopeProvider value={gridState}>
      {/* Outer container with padding */}
      {/* Inner card */}
      <div class="flex w-full flex-col rounded-xl border border-stroke-1 bg-background-normal-primary p-6">
        {/* Header with brand logo and amount */}
        <GcAmountHeader
          brandTitle={props.brand.voucherProductMetadata.title}
          brandLogoUrl={props.brand.voucherProductMetadata.sqLogoUrl}
          brandColor={getBrandColor()}
          isFreeText={isFreeTextHeader()}
        />

        {/* Amount selector section */}
        <div class="mt-4 flex w-full flex-col gap-3">
          <Switch>
            <Match when={isVariantBrand}>
              <AmountSelectorLonger />
            </Match>
            <Match when={true}>
              <AmountSelector />
            </Match>
          </Switch>
        </div>
        {/* Custom Amount Input */}
        <Show when={isCustomDenominationAllowed && customSelected()}>
          <div class="mt-3">
            <CustomAmountInput />
          </div>
        </Show>
        {/* Error Message Banner */}

        <div class="mt-4"></div>
        <GcAmountFooter />
        <div class="mt-3"></div>
        <RazorpayTrustMarker />
      </div>
    </DenominationsGridWebstoreTelescopeProvider>
  );
}

export function RazorpayTrustMarker() {
  return (
    <div class="inline-flex items-center justify-center gap-1 self-stretch">
      <div class=" text-label-regular text-text-normal-secondary">
        Safe & secure payment
      </div>
      <img
        class="h-4 w-20"
        src={
          "https://gullak-assets.s3.ap-south-1.amazonaws.com/icons/razorpay-trust-marker.png"
        }
        alt="Secure payments"
      />
    </div>
  );
}
